import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { endQuizRequested } from 'features/quizzes/actions';

export function* endQuizSaga(action: ReturnType<typeof endQuizRequested>) {
  yield call(SignalingSocket.send, { event: 'endQuiz', data: { id: action.payload } });
}
